var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#272731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 9.01688C15.1875 10.6538 14.5434 12.2231 13.3954 13.3807C12.8291 13.9529 12.1551 14.4071 11.4122 14.7172C10.6694 15.0273 9.87247 15.1872 9.0675 15.1875V13.6114C11.2883 13.6181 13.1878 12.0043 13.5585 9.7965H11.3704C11.457 9.54 11.5014 9.27112 11.502 9C11.4985 8.72939 11.4541 8.46086 11.3704 8.2035H13.5585C13.1827 5.9985 11.286 4.3875 9.0675 4.38863V2.8125C12.447 2.84512 15.1734 5.60925 15.1875 9.01688ZM11.1071 10.3438H12.8351C12.1961 12.2029 10.3196 13.3251 8.39531 12.9988C6.47156 12.6714 5.0625 10.9918 5.0625 9.02419C5.0625 7.05656 6.47156 5.3775 8.39531 5.05069C10.3196 4.72444 12.1961 5.84663 12.8351 7.70569H11.1071C10.9126 7.41002 10.6609 7.15624 10.3669 6.95925C10.098 6.78632 9.79759 6.6684 9.4829 6.61232C9.16821 6.55623 8.84552 6.5631 8.5335 6.63251C8.22148 6.70193 7.92632 6.83251 7.66508 7.01672C7.40385 7.20092 7.18173 7.4351 7.01156 7.70569C6.28931 8.84588 6.62063 10.3607 7.75181 11.0891C8.02061 11.2621 8.32103 11.38 8.6357 11.4362C8.95037 11.4923 9.27304 11.4855 9.58506 11.4161C9.89708 11.3467 10.1922 11.2162 10.4535 11.0321C10.7148 10.8479 10.9369 10.6144 11.1071 10.3438Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdt);
export default __webpack_public_path__ + "static/media/cdt.fd9b0bf5228358bfe9ac76ad116b1803.svg";
export { ForwardRef as ReactComponent };